import React from 'react'
import { NavbarSecondary } from 'stylist'
import styled from 'react-emotion'

const NavItem = styled(NavbarSecondary.NavItem)`
  && {
    border-bottom-color: transparent;
  }
`

const AdminSubnav = ({ match: { url } }) => (
  <NavbarSecondary dark>
    <NavItem to={`${url}/users`}>Users</NavItem>
    <NavItem to={`${url}/features`}>Features</NavItem>
    <NavItem to={`${url}/feedback`}>Feedback</NavItem>
  </NavbarSecondary>
)

export default AdminSubnav



// WEBPACK FOOTER //
// ./src/components/AdminSubnav.js